module.exports = __webpack_public_path__ + "assets/img/Type E (39).f7b425e2.jpg";